import actions from 'actions';

/**
 * initialState
 * @type {{title: {mobile: string, desktop: string}, number: number}}
 */
export const initialState = {
    id: null,
    number: 0,
    events: {},
    valid: false,
    isLast: false,
};

/**
 * reducer steps
 */
export default function generateReducer(steps) {
    return function stepsReducer(state = initialState, action) {
        const changedStep = steps[action.step - 1] || {};

        switch (action.type) {
            case actions.CHANGE_STEP:
                return {
                    ...state,
                    id: changedStep.id,
                    number: action.step,
                    valid:
                        action.step > 0
                            ? changedStep.defaultValid || action.step < state.number
                            : false,
                };
            case actions.GA_STEP: {
                return {
                    ...state,
                    events: {
                        ...state.events,
                        [action.step]: { ...state.events[action.step], [action.event]: true },
                    },
                };
            }
            case actions.GA_SUBMIT: {
                return {
                    ...state,
                    events: {
                        ...state.events,
                        [action.source]: { ...state.events[action.source], [action.event]: true },
                    },
                };
            }
            case actions.VALID_STEP: {
                return {
                    ...state,
                    valid: action.isValid,
                };
            }
            case actions.SET_LAST_STEP: {
                if (action.isLast) {
                    return {
                        ...state,
                        isLast: action.isLast,
                        events: { ...state.events, global: { ...state.events.global, auth: true } },
                    };
                }
                return {
                    ...state,
                    isLast: action.isLast,
                };
            }
            default:
                return state;
        }
    };
}
